import { render, staticRenderFns } from "./AddWarranty.vue?vue&type=template&id=ae3ef35e&"
import script from "./AddWarranty.vue?vue&type=script&lang=js&"
export * from "./AddWarranty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports